export const SCORING_CONFIG = Object.freeze({
  engagementFloor: 0.5,
});

export const SCORING_WEIGHTS = Object.freeze({
  feedback: 0.65,
  engagement: 0.35,
});

export function calculateFinalScore({
  averageRating,
  responsesReceived,
  totalMentees,
  engagementScore,
}) {
  const rating = Number(averageRating) || 0;
  if (rating <= 0) return 0;

  const feedbackScore = (rating / 5) * 100;
  const engagement =
    engagementScore !== undefined
      ? Number(engagementScore) || 0
      : totalMentees
      ? ((Number(responsesReceived) || 0) / totalMentees) * 100
      : 0;

  const scale =
    SCORING_CONFIG.engagementFloor +
    (1 - SCORING_CONFIG.engagementFloor) * (Math.max(0, Math.min(100, engagement)) / 100);

  return feedbackScore * scale;
}

export function formatScore(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "-";
  }

  return `${Number(value).toFixed(1)} / 100`;
}

export function formatPercent(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "-";
  }

  return `${Number(value).toFixed(1)}%`;
}

export function formatRating(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "-";
  }

  return `${Number(value).toFixed(2)} / 5`;
}
